import { Box, type BoxProps, Flex, Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import {
  Link,
  LogoAmericanExpress,
  LogoMastercard,
  LogoTroy,
  LogoVisa,
} from '@/components';

import {
  Distance_Sales_Contract_URL,
  Privacy_Policy_URL,
} from '../legal/constants';
import { COACH_FOOTER_HEIGHT } from './constants';

export const CoachFooter = (props: BoxProps) => {
  const { t } = useTranslation(['legal']);

  return (
    <Box {...props}>
      <Flex
        bottom="0"
        insetStart="0"
        insetEnd="0"
        bg="white"
        boxShadow="layout"
        borderBottom="1px solid transparent"
        as="footer"
        role="contentinfo"
        justify="center"
        py={{ base: '6', md: '4' }}
        h={COACH_FOOTER_HEIGHT}
      >
        <Flex
          grow={1}
          flex={1}
          px={4}
          maxW="container.xl"
          justify="space-between"
          direction={{ base: 'column', md: 'row' }}
          align={{ md: 'center' }}
        >
          {/* <Stack py={{ base: 4, md: 0 }}>
            <Logo />
            <Flex display={{ base: 'none', md: 'block' }}>
              <Trans
                i18nKey="copyright"
                ns="common"
                values={{ year: new Date().getFullYear() }}
              />
            </Flex>
          </Stack> */}
          <Stack
            direction={{ base: 'column', md: 'row' }}
            gap={{ base: 2, md: 8 }}
          >
            <Stack>
              <Link to="/legal/about-us">{t('legal:titles.aboutUs')}</Link>
              <Link to={Privacy_Policy_URL}>
                {t('legal:titles.privacyPolicy')}
              </Link>
            </Stack>
            <Stack>
              <Link to={Distance_Sales_Contract_URL}>
                {t('legal:titles.distanceSaleContract')}
              </Link>
              <Link to="/legal/delivery-and-return-policy">
                {t('legal:titles.deliveryAndReturnTerms')}
              </Link>
            </Stack>
          </Stack>
          <Stack direction="row" align="flex-start" pt={{ base: 4, md: 2 }}>
            <LogoMastercard fontSize={60} lineHeight={0.8} />
            <LogoVisa fontSize={60} lineHeight={0.8} />
            <LogoAmericanExpress fontSize={60} lineHeight={0.8} />
            <LogoTroy fontSize={60} lineHeight={0.8} />
          </Stack>
        </Flex>
      </Flex>
    </Box>
  );
};
